/* Gentle autoplay for the Shophaus Google Reviews carousel — the app renders its review row
   asynchronously (Alpine.js, after its own API fetch), so a MutationObserver is used instead of
   a fixed timeout to catch it whenever it actually appears. Autoplay pauses permanently on any
   user interaction with the row, and never runs for reduced-motion users, matching the pattern
   used elsewhere on this site (hero banner, customer-photo carousel). */
(function () {
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var wired = new WeakSet();

  function wire(track) {
    if (reduceMotion || wired.has(track)) return;
    wired.add(track);

    var autoplayId = null;

    function stepWidth() {
      var card = track.querySelector('.review-card');
      var gap = parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap) || 0;
      return card ? card.getBoundingClientRect().width + gap : track.clientWidth;
    }

    function stop() {
      if (autoplayId) {
        clearInterval(autoplayId);
        autoplayId = null;
      }
    }

    function start() {
      if (autoplayId) return;
      autoplayId = setInterval(function () {
        var atEnd = track.scrollLeft + track.clientWidth >= track.scrollWidth - 4;
        if (atEnd) {
          track.scrollTo({ left: 0, behavior: 'smooth' });
        } else {
          track.scrollBy({ left: stepWidth(), behavior: 'smooth' });
        }
      }, 3500);
    }

    ['pointerdown', 'wheel', 'touchstart'].forEach(function (evt) {
      track.addEventListener(evt, stop, { passive: true });
    });

    var wrap = track.closest('.google-reviews-widget') || track.parentElement;
    if (wrap) {
      wrap.querySelectorAll('.widget-slider-button').forEach(function (btn) {
        btn.addEventListener('click', stop);
      });
    }

    start();
  }

  document.querySelectorAll('.reviews-section').forEach(wire);

  var observer = new MutationObserver(function () {
    document.querySelectorAll('.reviews-section').forEach(wire);
  });
  observer.observe(document.body, { childList: true, subtree: true });
})();
